// extracted by mini-css-extract-plugin
export var numpadContainer = "_s9-1";
export var phoneButton = "_s9-0";